/*
 * extension jquery pour prendre en compte le selecteur :invalid
 */
jQuery.extend(jQuery.expr[':'], {
	invalid : function(elem, index, match) {
		var invalids = document.querySelectorAll(':invalid'),
		result = false,
		len = invalids.length;

		if (len) {
			for (var i=0; i<len; i++) {
				if (elem === invalids[i]) {
					result = true;
					break;
				}
			}
		}
		return result;
	}
});


/*
 * validation des formulaires
 */
$(document).on('submit', 'form.needs-validation', function(e) {
	var $this = $(this);
	if( $this[0].checkValidity() === false ) {
		e.preventDefault();
		e.stopPropagation();
	}
	$this.addClass('was-validated');

	fixBootstrapSelectValidation();


	if( $('*:invalid', $this).get().length ) {
		// si le champ invalide est collapsed
		if( $('*:invalid:hidden:eq(0)', $this).parents('.collapse:not(.show)').get().length ) {
			$('*:invalid:hidden:eq(0)', $this).parents('.collapse:not(.show)').collapse('show');
			setTimeout(function() {
				scrollToInvalidField($this)
			}, 350);
		}
		else
			scrollToInvalidField($this);
	}

	function scrollToInvalidField($this) {
		var offset = $('#navbar-form').get().length ? $('#navbar-form').height() + 40 : 40;
		// si pas de champ invalide visible -> on change la langue pour le premier champ invalide invisible
		if( !$('*:invalid:visible', $this).get().length ) {
			$('.lang_selector .btn[data-lang="' + $($('*:invalid:hidden', $this).parents('.form-group')).data('lang') + '"]').click();
		}
		//on scrolle jusqu'au premier champ invalide
		if( $('.fancybox-container.fancybox-is-open').get().length ) {
			var pos = $($('*:invalid:visible:eq(0)', $this).parent()[0]).offset().top;
			var pos2 = $($('*:invalid:visible:eq(0)', $this).parents('form')[0]).offset().top;
			$('.fancybox-container.fancybox-is-open .fancybox-slide--current').animate({scrollTop: pos - pos2 }, 200);
		}
		else
			$('html, body').animate({scrollTop: $($('*:invalid:visible:eq(0)', $this).parent()).offset().top - offset}, 200);
		$('*:invalid:visible:eq(0)', $this).focus();
	}
});


/*
 * validation serveur => scroll à la première erreur si erreur
 */
$(window).on('load', function() {
	if( $('.form-group *.is-invalid').get().length ) {
		// si pas de champ invalide visible -> on change la langue pour le premier champ invalide invisible
		if( !$('.form-group *.is-invalid:visible').get().length ) {
			$('.lang_selector .btn[data-lang="' + $($('.form-group *.is-invalid:hidden').parents('.form-group')).data('lang') + '"]').click();
		}
		//on scrolle jusqu'au premier champ invalide
		$('html, body').animate({scrollTop: $($('.form-group *.is-invalid:visible:eq(0)').parents('.form-group')).position().top }, 10);
	}
});


/*
 * fix bootstrap-select validation
 */
function fixBootstrapSelectValidation() {
	$('.form-group:has(.bootstrap-select.form-control) > .invalid-feedback').css('display', 'none');
	$('.form-group:has(.bootstrap-select.form-control > :invalid) > .invalid-feedback, .form-group:has(.bootstrap-select.form-control > .is-invalid) > .invalid-feedback').css('display', 'block');
}
window.fixBootstrapSelectValidation = fixBootstrapSelectValidation;

/*$(function() {
	fixBootstrapSelectValidation();
});*/

$(document).on('change', '.was-validated .selectpicker.form-control, .was-validated .selectpicker.form-control', function() {
	fixBootstrapSelectValidation();
});



/*
 * modification des paramètres par defaut de bootstrap-select
 */
$.fn.selectpicker.Constructor.DEFAULTS.liveSearchNormalize = true;
$.fn.selectpicker.Constructor.DEFAULTS.virtualScroll = false;
//$.fn.selectpicker.Constructor.DEFAULTS.liveSearchPlaceholder = __str('Search');
//$.fn.selectpicker.Constructor.DEFAULTS.noneResultsText = __str('No result');


/*
 * discard select
 */
$('.selectpicker.discard').on('changed.bs.select loaded.bs.select', function() {
	var $this = $(this);
	if( $this.val() != '' ) {
		if( !$this.next('._selectpicker_clear').length )
			$this.after('<div class="_selectpicker_clear">&times;</div>');
	}
	else {
		$this.next('._selectpicker_clear').remove();
	}
	$this.parent().find('.btn.dropdown-toggle').blur();
});
$(document).on('click', '._selectpicker_clear', function() {
	var $this = $(this);
	$this.prev('.selectpicker').selectpicker('val', '');
	$this.remove();
});


/**
 * 
 * profils export
 * 
 */
$('.profils_export .selectpicker').on('changed.bs.select loaded.bs.select', function() {
	var $this = $(this);
	if( $this.val() != '' ) {
		var value = JSON.parse($this.val());
		document.querySelectorAll('.export_colonnes .form-check-input').forEach(el => {
			let t = el.name.match(/\[(.*?)\]/);
			if ( t.length ) {
				el.checked = value.champs.indexOf(t[1]) != -1;
			}
			if ( value.id == 1 ) {
				el.parentElement.parentElement.classList.remove('d-none');
			} else {
				if ( el.checked ) {
					el.parentElement.parentElement.classList.remove('d-none');
				} else {
					el.parentElement.parentElement.classList.add('d-none');
				}
			}
		});
		if ( value.user ) {
			$this.parents('.profils_export').find('.actions').html('<span class="rename_zone d-inline-flex align-items-center"><a href="#" class="rename btn btn-outline-secondary btn-sm">renommer</a></span><span class="update_zone d-inline-flex align-items-center ml-2"><a href="#" class="update btn btn-outline-secondary btn-sm">mettre à jour</a></span><span class="delete_zone d-inline-flex align-items-center ml-2"><a href="#" class="delete btn btn-outline-danger btn-sm">supprimer</a></span><span class="new_zone d-inline-flex align-items-center ml-3"><a href="#" class="new btn btn-outline-success btn-sm">nouveau profil</a></span>');
		} else {
			$this.parents('.profils_export').find('.actions').html('<span class="new_zone d-inline-flex align-items-center"><a href="#" class="new btn btn-outline-success btn-sm">nouveau profil</a></span>');
		}
	} else {
		$this.parents('.profils_export').find('.actions').html('<span class="new_zone d-inline-flex align-items-center"><a href="#" class="new btn btn-outline-success btn-sm">nouveau profil</a></span>');
	}
});

$(document).on('click', '.profils_export .actions .new', function(e) {
	e.preventDefault();
	var $this = $(this);
	$this.parent().html('<input class="form-control form-control-sm" type="text" placeholder="Nouveau profil"><a href="#" class="new_add btn btn-link text-success btn-sm"><i class="material-icons">check</i></a><a href="#" class="new_cancel btn btn-link text-danger btn-sm px-0"><i class="material-icons">close</i></a>');
});

$(document).on('click', '.profils_export .actions .new_cancel', function(e) {
	e.preventDefault();
	var $this = $(this);
	$this.parent().html('<a href="#" class="new btn btn-outline-success btn-sm">nouveau profil</a>');
});

$(document).on('click', '.profils_export .actions .new_add', function(e) {
	e.preventDefault();
	var $this = $(this);
	let $container = $this.parents('.profils_export');
	let nom = $this.parent().find('input').val();
	let champs = [];
	document.querySelectorAll('.export_colonnes .form-check-input:checked').forEach(el => {
		let t = el.name.match(/\[(.*?)\]/);
		if ( t.length ) {
			champs.push(t[1]);
		}
	});
	if ( nom != '' ) {
		$.ajax({
			type: "POST",
			url: $container.data('url'),
			dataType: 'json',
			data: { action: 'profilsexportadd', nom: nom, champs: JSON.stringify(champs) }
		}).done(function(data) {
			if( data.success ) {
				let $select = $container.find('.form-control.selectpicker');
				let value = {
					id: data.id,
					user: 1,
					nom: nom,
					champs: champs,
				};
				value = JSON.stringify(value);
				const option = document.createElement('option');
				option.value = value;
				option.textContent = nom;
				$select.append(option);
				$select.selectpicker('refresh');
				$select.selectpicker('val', value);
			}
		});
	}
});

$(document).on('click', '.profils_export .actions .rename', function(e) {
	e.preventDefault();
	var $this = $(this);
	$this.parent().html('<input class="form-control form-control-sm" type="text" placeholder="Nouveau nom" value="' + $this.parents('.profils_export').find('.form-control.selectpicker option:selected').text() + '"><a href="#" class="rename_confirm btn btn-link text-success btn-sm"><i class="material-icons">check</i></a><a href="#" class="rename_cancel btn btn-link text-danger btn-sm px-0"><i class="material-icons">close</i></a>');
});

$(document).on('click', '.profils_export .actions .rename_cancel', function(e) {
	e.preventDefault();
	var $this = $(this);
	$this.parent().html('<a href="#" class="rename btn btn-outline-secondary btn-sm">renommer</a>');
});

$(document).on('click', '.profils_export .actions .rename_confirm', function(e) {
	e.preventDefault();
	var $this = $(this);
	let $container = $this.parents('.profils_export');
	let nom = $this.parent().find('input').val();
	let $select = $container.find('.form-control.selectpicker');
	let value = JSON.parse($select.val());
	if ( nom != '' ) {
		$.ajax({
			type: "POST",
			url: $container.data('url'),
			dataType: 'json',
			data: { action: 'profilsexportrename', id: value.id, nom: nom }
		}).done(function(data) {
			if( data.success ) {
				$select.find('option:selected').text(nom);
				$select.selectpicker('refresh');
				$this.parent().html('<a href="#" class="rename btn btn-outline-secondary btn-sm">renommer</a>');
			}
		});
	}
});

$(document).on('click', '.profils_export .actions .update', function(e) {
	e.preventDefault();
	e.target.classList.remove('update', 'btn-outline-secondary');
	e.target.classList.add('update_confirm', 'btn-outline-success');
	e.target.textContent = 'sauvegarder';
	document.querySelectorAll('.export_colonnes .form-check-input').forEach(el => {
		el.parentElement.parentElement.classList.remove('d-none');
	});
});

$(document).on('click', '.profils_export .actions .update_confirm', function(e) {
	e.preventDefault();
	var $this = $(this);
	let $container = $this.parents('.profils_export');
	let $select = $container.find('.form-control.selectpicker');
	let value = JSON.parse($select.val());
	let champs = [];
	document.querySelectorAll('.export_colonnes .form-check-input:checked').forEach(el => {
		let t = el.name.match(/\[(.*?)\]/);
		if ( t.length ) {
			champs.push(t[1]);
		}
	});
	if ( value.id ) {
		$.ajax({
			type: "POST",
			url: $container.data('url'),
			dataType: 'json',
			data: { action: 'profilsexportupdate', id: value.id, champs: JSON.stringify(champs) }
		}).done(function(data) {
			if( data.success ) {
				value.champs = champs;
				value = JSON.stringify(value);
				$select.find('option:selected').val(value);
				$select.selectpicker('refresh');
				$this.after('<i class="material-icons text-success ml-1">check</i>');
				setTimeout(() => {
					$this.next('i').remove();
				}, 1000);
			}
		});
	}
});

$(document).on('click', '.profils_export .actions .delete', function(e) {
	e.preventDefault();
	var $this = $(this);
	let $container = $this.parents('.profils_export');
	let $select = $container.find('.form-control.selectpicker');
	let value = JSON.parse($select.val());
	if ( value.id ) {
		$.ajax({
			type: "POST",
			url: $container.data('url'),
			dataType: 'json',
			data: { action: 'profilsexportdelete', id: value.id }
		}).done(function(data) {
			if( data.success ) {
				$select.find('option:selected').remove();
				$select.selectpicker('refresh');
				$select.selectpicker('val', '');
			}
		});
	}
});



/*
 * filtre des listes
 */
$(document).on('click', '._filter[data-href]', function(e) {
	e.preventDefault();
	var $this = $(this);
	var $container = $this.is('[data-container]') ? $($this.data('container')) : $this.parent();
	var values = $('input, textarea, select', $container).serializeObject();
	location.href = $this.data('href') + Base64.encode( JSON.stringify(values) );
});
$(document).on('change', '#filters_display_disabled', function(e) {
	var $this = $(this);
	if ( $this.prop('checked') ) {
		$('.selectpicker[name="id"] option.tohide').prop('disabled', false);
	} else {
		$('.selectpicker[name="id"] option.tohide').prop('disabled', true);
	}
});
$('#filters_display_disabled').change();


/*
 * navigation dans le formulaire
 */
$(document).on('click', '#navbar-form a', function(e) {
	e.preventDefault();
	var $this = $(this);
	$('html, body').animate({ scrollTop: $($this.attr('href')).offset().top - $('#navbar-form').height() }, 200);
});



$(document).on('blur', '._formatprix', function() {
	$(this).val( prixFormat($(this).val()) );
});


// formate les prix
function prixFormat(prix) {
	prix = getPrixFormat(prix);
	if( prix != '' && !isNaN(prix) ) {
		var n = new Intl.NumberFormat('fr',{ maximumFractionDigits: 2 });
		var v = n.format(prix);
		// fix 2 chiffres après la virgule
		if( v.match(/,\d$/) )
			v += '0';
		return v;
	}
	else
		return prix;
}
window.prixFormat = prixFormat;

function getPrixFormat(prix) {
	return prix.toString().replace(/\s/g, '').replace(',', '.').replace(/[^0-9\.]/g, '');
}
window.getPrixFormat = getPrixFormat;



/*
 * bouton toggle active
 */
$(document).on('click', '[data-toggle-active][data-href]', function(e) {
	e.preventDefault();
	var $this = $(this);
	$.ajax({
		type: "POST",
		url: $this.data('href'),
		dataType: 'json',
		data: { action: 'toggleactive' }
	}).done(function(data) {
		if( data.success ) {
			$this.removeClass('text-success text-danger').html('');
			if( data.active == 0 )
				$this.addClass('text-danger').html('<i class="material-icons">clear</i>');
			else
				$this.addClass('text-success').html('<i class="material-icons">done</i>');
			$this.trigger('toggle:change');
		}
	});
});


/*
 * input defaultvalue
 */
function checkInputDefaultValue(el) {
	if( $(el).val() == '' )
		$(el).val( $(el).data('defaultvalue') );
}

$('input[data-defaultvalue]').each(function(i, el) {
	checkInputDefaultValue(el);
});
$('input[data-defaultvalue]').on('input', function(e) {
	checkInputDefaultValue(e.target);
});


//
// section collapse
//
$('.section-collapse').on('show.bs.collapse hide.bs.collapse', function() {
	var $this = $(this);
	$('.section-collapse-link[aria-controls="' + $this.attr('id') + '"] .material-icons').toggleClass('d-none');
});


//
// dynamic_mailto : ajoute un lien mailto sur le prepend du champ
//
function update_dynamic_mailto(el) {
	if( $('input', el).val() != '' )
		$('.input-group-prepend .input-group-text', el).html('<a target="_blank" href="mailto:' + $('input', el).val() + '"><i class="material-icons">email</i></a>');
	else
		$('.input-group-prepend .input-group-text', el).html('<i class="material-icons">email</i>');
}
$('.dynamic_mailto').each(function(i, el) {
	update_dynamic_mailto(el);
	$('input', el).on('input', function() {
		update_dynamic_mailto(el);
	});
});